import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import SearchSq from "Component/Material-ui/SearchSq";
import headersList from "Constants/headersList";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
// import { SaveEmployeeid } from "Actions/commonAction";

import probation from "Assets/Svg/probation.svg";
import designation from "Assets/Svg/designation.svg";
import shift from "Assets/Svg/shift.svg";
import extratime from "Assets/Svg/extra-time.svg";
import payroll from "Assets/Svg/payroll.svg";
import holiday from "Assets/Svg/holiday.svg";
import leave from "Assets/Svg/leave.svg";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { FEATUREKEYS } from "../../../Constants";
import "./index.css";
import { instance } from "../../../Actions/AxiosInstance";

// {planner: 180},
const plannerConstant = [
  {
    key: FEATUREKEYS.planner_probation,
    name: "Probations",
    route: "probationplanner",
    description:
      "Start (assign), extend or confirm the completion of an employee's probation from the probation planner here.",
    img: probation,
  },
  {
    key: FEATUREKEYS.planner_designation,
    name: "Designations",
    route: "designationplanner",
    description:
      "Assign or update designations (aka Job Titles). You can also plan future changes in advance from this planner.",
    img: designation,
  },
  {
    key: FEATUREKEYS.planner_shift,
    name: "Shift plans",
    route: "shiftplanner",
    description:
      "Change past shift assignments & plan future shifts along with attendance policy, weekly off & clock-in method.",
    img: shift,
  },
  {
    key: FEATUREKEYS.planner_extratime,
    name: "Extra-time policies",
    route: "extratimeplanner",
    description:
      "Assign ET policies to credit comp-off leaves or over-time payments to employees for working beyond shift hours.",
    img: extratime,
  },
  {
    key: FEATUREKEYS.planner_leavePolicy,
    name: "Leave policies",
    route: "leavepolicyplanner",
    description:
      "Assign a leave policy (collection of rules for each leave type) to individual or multiple employees for the ongoing leave cycle.",
    img: leave,
  },
  {
    key: FEATUREKEYS.planner_holiday,
    name: "Holidays",
    route: "holidayplanner",
    description:
      "Assign holiday plans with mandatory and optional holidays to individual or multiple employees.",
    img: holiday,
  },
  {
    key: FEATUREKEYS.planner_payroll,
    name: "Payroll assignments",
    route: "payroll",
    description:
      "Assign the right salary structure or flexible benefit plan, and revise the pay package of employees here.",
    img: payroll,
  },
];

const LIVEDATA_LIST = [
  {
    key: "livedata_attendanceregularization",
    id: FEATUREKEYS.livedata_attendanceregularization,
    name: "Attendance regularization",
    route: "attendance_regularization",
    description:
      "Update employee's attendance logs for missed days. Start with the filter, update timestamps, preview & save.",
    typeid: 1,
  },
  {
    key: "livedata_leaveadjustment",
    id: FEATUREKEYS.livedata_leaveadjustment,
    name: "Adjust leave balance",
    route: "leave_adjustment",
    description:
      "Credit or debit employee leave balance (overriding policy rules). Filter down by leave type & leave policy, before getting started.",
    typeid: 1,
  },
  {
    key: "livedata_bulkleaveapplication",
    id: FEATUREKEYS.livedata_bulkleaveapplication,
    name: "Bulk leave application",
    route: "bulk_leave_application",
    description:
      "Apply for leaves in bulk on behalf of employees at the same time. Filter down by leave policy before you get started.",
    typeid: 1,
  },
  {
    key: "livedata_employeeDeviceMapping",
    id: FEATUREKEYS.livedata_employeeDeviceMapping,
    name: "Biometric device mapping",
    route: "employee_device_mapping",
    description:
      "Assign employees to their registered biometric device(s). Filter down by devices/groups before you get started.",
    typeid: 1,
  },
  {
    key: "livedata_newemployee",
    id: FEATUREKEYS.livedata_newemployee,
    name: "Bulk-add new employees",
    route: "addnewemployee",
    description:
      "Add several employees with their profile info by using our import-template for quick & convenient bulk-addition of profiles.",
    typeid: 3,
  },
  {
    key: "livedata_employeeID",
    id: FEATUREKEYS.livedata_employeeID,
    name: "Employee codes/IDs",
    route: "employeecode",
    description:
      "Specify manually defined ID codes for employees. Apply filters or scroll around to find the employees you’re looking for.",
    typeid: 3,
  },
  {
    key: "livedata_expensePolicy",
    id: FEATUREKEYS.livedata_expensePolicy,
    name: "Expense claims policy",
    route: "expensepolicy",
    description:
      "Apply filters to find the employee(s) to assign expense claims policy to one or many employees at the same time.",
    typeid: 2,
  },
  {
    key: "livedata_approvalWorkflow",
    id: FEATUREKEYS.livedata_approvalWorkflow,
    name: "Approval workflow",
    route: "approval_workflow",
    description:
      "Assign or change approval workflows for your employees. You can do individual or bulk changes.",
    typeid: 2,
  },
  {
    key: "livedata_exitPolicy",
    id: FEATUREKEYS.livedata_exitPolicy,
    name: "Exit policy (notice periods)",
    route: "exitpolicy",
    description:
      "Without an exit policy, employees cannot resign or be deactivated. Go here to assign an exit policy & a notice period.",
    typeid: 2,
  },
  {
    key: "livedata_employeeWorkProfile",
    id: FEATUREKEYS.livedata_employeeWorkProfile,
    name: "Employee work profile",
    route: "workprofile",
    description:
      "Assign/change multiple work profile details like business unit, department and designation, with effective dates!",
    typeid: 3,
  },
  {
    key: "livedata_managers",
    id: FEATUREKEYS.livedata_managers,
    name: "Manager assignment",
    route: "managers",
    description:
      "Assign or change not only a Primary reporting manager but also secondary managers to employees.",
    typeid: 3,
  },
  {
    key: "livedata_team",
    id: FEATUREKEYS.livedata_team,
    name: "Team assignment",
    route: "team",
    description:
      "Assign or change the employees’ team as they move from one team to another. Remember, preview before saving.",
    typeid: 3,
  },
  {
    key: "livedata_Statutory",
    id: FEATUREKEYS.livedata_statutory,
    name: "Statutory & identity data",
    route: "statutory",
    description:
      "Add or update the employee's multiple statutory and identity data points in bulk.",
    typeid: 3,
  },
  {
    key: "livedata_grade",
    id: FEATUREKEYS.livedata_grade,
    name: "Grade assignment",
    route: "grade",
    description:
      "Assign grades or leave it blank. Double click to pick a grade from the pre configured drop down. Preview changes and save.",
    typeid: 3,
  },
  {
    key: "livedata_asset",
    id: FEATUREKEYS.livedata_grade,
    name: "Asset assignment",
    route: "assetassignment",
    description:
      "Assign asset. Double click to pick a asset from the pre configured drop down. Preview changes and save.",
    typeid: 3,
  },
  {
    key: "livedata_defaultPermission",
    id: FEATUREKEYS.livedata_defaultPermission,
    name: "Default access/roles",
    route: "default_permission",
    description:
      "Assign who gets the Admin/Manager/Employee access roles. Apply easy filters to reach the right set of employees.",
    typeid: 2,
  },
  {
    key: "livedata_permissionPolicy",
    id: FEATUREKEYS.livedata_permissionPolicy,
    name: "Permission policy",
    route: "permissionpolicy",
    description:
      "Created special permissions? Assign permission policies to the required employees here, before you preview & save.",
    typeid: 2,
  },
  {
    key: "livedata_employementType",
    id: FEATUREKEYS.livedata_employementType,
    name: "Employment type",
    route: "employementtype",
    description:
      "Full time, Part time, Internship, Apprenticeship, Contract or Consultant - assign a type to each employee, as you deem fit.",
    typeid: 3,
  },
  {
    key: "livedata_reportingOffice",
    id: FEATUREKEYS.livedata_reportingOffice,
    name: "Reporting office",
    route: "reportingoffice",
    description:
      "Appoint a reporting office to your employees. Use name, employee code or designation to find the right ones for assignment.",
    typeid: 3,
  },
  {
    key: "livedata_selfService",
    id: FEATUREKEYS.livedata_selfService,
    name: "Self-service access",
    route: "selfservice",
    description:
      "Allow or deny self-service access to employees by using the dropdown 'Yes/No' or change their email/phone number.",
    typeid: 2,
  },
  {
    key: "livedata_payrolltags",
    id: FEATUREKEYS.livedata_payrolltags,
    name: "Payroll tags",
    route: "payrolltags",
    description:
      "Add/ change details related to Payroll tags such as Handicap and Metro. Preview changes and save the information",
    typeid: 4,
  },
  {
    key: "livedata_payrolltags",
    id: FEATUREKEYS.livedata_exitemployee,
    name: "Deactivate employees",
    route: "deactivate_exit_employee",
    description:
      "A step in your farewell process. Select the exit policy, exit reason and other important details as you deactivate employee(s).",
    typeid: 3,
  },
  {
    key: "livedata_extrapayment",
    id: FEATUREKEYS.livedata_extrapayment,
    name: "Extra Payments",
    route: "extra_payment",
    description:
      "Apply filters according to your preference and assign/ edit information related to extra payments. Preview changes and save.",
    typeid: 4,
  },
  {
    key: "livedata_extradeduction",
    id: FEATUREKEYS.livedata_extradeduction,
    name: "Extra deduction",
    route: "extra_deduction",
    description:
      "Create a deduction component to use this feature. Add filters and alter deduction details. Remember to preview changes before saving.",
    typeid: 4,
  },
  {
    key: "livedata_bankdetail",
    id: FEATUREKEYS.livedata_bankdetail,
    name: "Bank detail",
    route: "bank_detail",
    description:
      "Add/view/change all information related to employees’ bank accounts here. Remember to preview changes before saving.",
    typeid: 4,
  },
  {
    key: "livedata_salarystructure",
    id: FEATUREKEYS.livedata_salarystructure,
    name: "Salary structure",
    route: "salary_structure",
    description:
      "Upload data in a bulk by downloading template and reuploading it or add/ change information for employees individually. Remember to preview changes before saving.",
    typeid: 4,
  },
  {
    key: "livedata_payslip",
    id: FEATUREKEYS.livedata_payslip,
    name: "Payslip",
    route: "payslip",
    description:
      "Select a salary cycle before adding details related to the payslip of employees. Filter and sort by applying simple filters. Preview and change the data.",
    typeid: 4,
  },
  {
    key: "livedata_proration",
    id: FEATUREKEYS.livedata_proration,
    name: "Proration",
    route: "proration",
    description:
      "Assign Salary Prorations to employees in bulk by downloading template and reuploading it or changing it via the interface. To get started choose a specific Salary Structure from the filter.",
    typeid: 4,
  },
  {
    key: "livedata_fnf",
    id: FEATUREKEYS.livedata_fnf,
    name: "FNF Settlement Policy",
    route: "fnf",
    description:
      "Select a policy form the drop down for the employee that you wish to assign/ edit FNF policy. Save after previewing changes.",
    typeid: 4,
  },
  {
    key: "livedata_fnf",
    id: FEATUREKEYS.livedata_fnf,
    name: "Non-Payroll Income",
    route: "non_payroll_income",
    description:
      "Upload data in a bulk by downloading template and reuploading it or add/ change information for employees individually. Remember to preview changes before saving.",
    typeid: 4,
  },
  {
    key: "livedata_incometaxdeclaration",
    id: FEATUREKEYS.payrolldashboard,
    name: "IT declaration",
    route: "income_tax_declaration",
    description:
      "Upload data in a bulk by downloading template and reuploading it or add/ change information for employees individually. Remember to preview changes before saving.",
    typeid: 4,
  },
  {
    key: "livedata_hradeclaration",
    id: FEATUREKEYS.payrolldashboard,
    name: "HRA declaration",
    route: "hra_declaration",
    description:
      "Upload data in a bulk by downloading template and reuploading it or add/ change information for employees individually. Remember to preview changes before saving.",
    typeid: 4,
  },
];

const styles = (theme) => ({
  button: {
    margin: 5,
    color: "white",
  },
});

class operations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: "",
      backupList: [
        ...LIVEDATA_LIST.filter(
          (x) =>
            get(this.props, "loginData.features", []).findIndex(
              (y) => x.id == y.featureid,
            ) != -1 || x.id == -99,
          // x.id == 368,
        ),
      ],
      options: plannerConstant.filter(
        (planner) =>
          get(this.props, "loginData.features", []).findIndex(
            (feature) => feature.featureid === planner.key,
          ) != -1,
      ),
      backupList1: [
        ...plannerConstant.filter(
          (planner) =>
            get(this.props, "loginData.features", []).findIndex(
              (feature) => feature.featureid === planner.key,
            ) != -1,
        ),
      ],

      LiveDataOptions: [
        ...LIVEDATA_LIST.filter(
          (x) =>
            get(this.props, "loginData.features", []).findIndex(
              (y) => x.id == y.featureid,
            ) != -1 || x.id == -99,
          // x.id == 368,
        ),
      ],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const data = {
      offset: 0,
      limit: 50,
    };
    instance
      .post("payroll/initsalaryassigned", data)
      .then((resp) => {
        this.setState({
          LiveDataOptions:
            get(resp, "data.result[0]", {}).payrolltypeid == 3
              ? this.state.LiveDataOptions.filter(
                (x) => x.id != FEATUREKEYS.livedata_salarystructure,
              )
              : this.state.LiveDataOptions.filter(
                (x) => x.id != FEATUREKEYS.livedata_proration,
              ),
          backupList:
            get(resp, "data.result[0]", {}).payrolltypeid == 3
              ? this.state.LiveDataOptions.filter(
                (x) => x.id != FEATUREKEYS.livedata_salarystructure,
              )
              : this.state.LiveDataOptions.filter(
                (x) => x.id != FEATUREKEYS.livedata_proration,
              ),
        });
      })
      .catch(() => {
        // this.props.enqueueSnackbar(
        //   error.response ? error.response.data.error.message : error.message,
        //   { variant: "error" },
        // );
      });
  }

  handleSearch(e) {
    const { backupList, backupList1 } = this.state;
    const filterList = backupList.filter(
      (item) =>
        item.name.toLowerCase().search(e.target.value.toLowerCase()) !== -1 ||
        item.description.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    const filterList1 = backupList1.filter(
      (item) =>
        item.name.toLowerCase().search(e.target.value.toLowerCase()) !== -1 ||
        item.description.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );

    this.setState({
      searchValue: e.target.value,
      LiveDataOptions: e.target.value ? filterList : backupList,
      options: e.target.value ? filterList1 : backupList1,
    });
  }

  setCurrentPage = (option) => {
    this.setState({ currentPage: option });
  };

  render() {
    const attendanceLiveData = this.state.LiveDataOptions.filter(
      (x) => x.typeid == 1,
    ).sort((a, b) => (a.name > b.name ? 1 : -1));

    const policiesLiveData = this.state.LiveDataOptions.filter(
      (x) => x.typeid == 2,
    ).sort((a, b) => (a.name > b.name ? 1 : -1));

    const employeeLiveData = this.state.LiveDataOptions.filter(
      (x) => x.typeid == 3,
    ).sort((a, b) => (a.name > b.name ? 1 : -1));
    console.log('employeeLiveData: ', employeeLiveData);

    const paymentsLiveData = this.state.LiveDataOptions.filter(
      (x) => x.typeid == 4,
    ).sort((a, b) => (a.name > b.name ? 1 : -1));

    return (
      <main className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Operation.header}</title>
        </Helmet>
        <Grid container>
          <Grid item md={12} sm={12} className="text-center">
            <p
              className="large-text-dark-secondary margin-bottom-24"
              style={{ fontSize: 25 }}
            >
              What would you like to do today?
            </p>
            <div className="margin-bottom-24 width50 text-align-center">
              <SearchSq
                placeholder="Search"
                value={this.state.searchValue}
                onChange={this.handleSearch}
              />
            </div>
          </Grid>
        </Grid>
        {this.state.options.length > 0 && (
          <div>
            <p className="large-text-dark-secondary margin-bottom-16">
              Planners
            </p>
            <Grid container spacing={2} className="margin-bottom-24">
              {this.state.options
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((option) => (
                  <Grid item md={4} sm={6}>
                    <Link
                      to={`./planner/${option.route}`}
                      target={this.state.currentPage !== "/planner" && "_blank"}
                    >
                      <Paper
                        className="rounded-rectangle-paper padding10 display-flex active-paper"
                        style={{ minHeight: 106 }}
                        // onClick={() => this.props.SaveEmployeeid(null)}
                        onClick={() => localStorage.removeItem("tempempid")}
                      >
                        <div>
                          <p className="normal-dark-secondary t-bold margin-bottom-8">
                            {option.name}
                          </p>
                          <p className="small-dark-secondary">
                            {option.description}
                          </p>
                        </div>
                        <div>
                          <img src={option.img}></img>
                        </div>
                      </Paper>
                    </Link>
                  </Grid>
                ))}
            </Grid>
          </div>
        )}
        {this.state.LiveDataOptions.length > 0 && (
          <p className="large-text-dark-secondary margin-bottom-16">
            HR Database
          </p>
        )}
        {attendanceLiveData.length > 0 && (
          <div>
            <p
              className="extra-small-dark-secondary t-bold margin-bottom-16"
              style={{
                background: "#fa6f5f",
                padding: "2px 8px",
                color: "#fff",
                display: "inline-block",
                borderRadius: 4,
              }}
            >
              Attendance and leaves
            </p>
            <Grid container spacing={2} className="margin-bottom-24">
              {attendanceLiveData.map((option) => (
                <Grid item md={3} sm={6}>
                  <Link
                    to={`./live_data/${option.route}`}
                    target={this.state.currentPage !== "/live_data" && "_blank"}
                  >
                    <Paper
                      className="rounded-rectangle-paper padding10 active-paper"
                      style={{ borderLeft: "4px solid #fa6f5f" }}
                      // onClick={() => this.props.SaveEmployeeid(null)}
                      onClick={() => localStorage.removeItem("tempempid")}
                    >
                      <div>
                        <p className="normal-dark-secondary t-bold margin-bottom-8">
                          {option.name}
                        </p>
                        <p className="small-dark-secondary">
                          {option.description}
                        </p>
                      </div>
                    </Paper>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {policiesLiveData.length > 0 && (
          <div>
            <p
              className="extra-small-dark-secondary t-bold margin-bottom-16"
              style={{
                background: "#faa500",
                padding: "2px 8px",
                color: "#fff",
                display: "inline-block",
                borderRadius: 4,
              }}
            >
              Workflow and policies
            </p>
            <Grid container spacing={2} className="margin-bottom-24">
              {policiesLiveData.map((option) => (
                <Grid item md={3} sm={6}>
                  <Link
                    to={`./live_data/${option.route}`}
                    target={this.state.currentPage !== "/live_data" && "_blank"}
                  >
                    <Paper
                      className="rounded-rectangle-paper padding10 active-paper"
                      style={{ borderLeft: "4px solid #faa500" }}
                      // onClick={() => this.props.SaveEmployeeid(null)}
                      onClick={() => localStorage.removeItem("tempempid")}
                    >
                      <div>
                        <p className="normal-dark-secondary t-bold margin-bottom-8">
                          {option.name}
                        </p>
                        <p className="small-dark-secondary">
                          {option.description}
                        </p>
                      </div>
                    </Paper>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {employeeLiveData.length > 0 && (
          <div>
            <p
              className="extra-small-dark-secondary t-bold margin-bottom-16"
              style={{
                background: "#8259d9",
                padding: "2px 8px",
                color: "#fff",
                display: "inline-block",
                borderRadius: 4,
              }}
            >
              Employee related
            </p>
            <Grid container spacing={2} className="margin-bottom-24">
              {employeeLiveData.map((option) => (
                <Grid item md={3} sm={6}>
                  <Link
                    to={`./live_data/${option.route}`}
                    target={this.state.currentPage !== "/live_data" && "_blank"}
                  >
                    <Paper
                      className="rounded-rectangle-paper padding10 active-paper"
                      style={{ borderLeft: "4px solid #8259d9" }}
                      // onClick={() => this.props.SaveEmployeeid(null)}
                      onClick={() => localStorage.removeItem("tempempid")}
                    >
                      <div>
                        <p className="normal-dark-secondary t-bold margin-bottom-8">
                          {option.name}
                        </p>
                        <p className="small-dark-secondary">
                          {option.description}
                        </p>
                      </div>
                    </Paper>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {paymentsLiveData.length > 0 && (
          <div>
            <p
              className="extra-small-dark-secondary t-bold margin-bottom-16"
              style={{
                background: "#46d2db",
                padding: "2px 8px",
                color: "#fff",
                display: "inline-block",
                borderRadius: 4,
              }}
            >
              Salary and payments
            </p>
            <Grid container spacing={2} className="margin-bottom-24">
              {paymentsLiveData.map((option) => (
                <Grid item md={3} sm={6}>
                  <Link
                    to={`./live_data/${option.route}`}
                    target={this.state.currentPage !== "/live_data" && "_blank"}
                  >
                    <Paper
                      className="rounded-rectangle-paper padding10 active-paper"
                      style={{ borderLeft: "4px solid #46d2db" }}
                      // onClick={() => this.props.SaveEmployeeid(null)}
                      onClick={() => localStorage.removeItem("tempempid")}
                    >
                      <div>
                        <p className="normal-dark-secondary t-bold margin-bottom-8">
                          {option.name}
                        </p>
                        <p className="small-dark-secondary">
                          {option.description}
                        </p>
                      </div>
                    </Paper>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {this.state.LiveDataOptions.length == 0 &&
          this.state.options.length == 0 && (
            <div className="position-rel">
              <DefaultComp
                heading="There are no results!"
                subheading=""
                imageSrc={emptylist}
              />
            </div>
          )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  menus: get(state, "AuthenticationAction.login.menuaction", []),
  loginData: get(state, "AuthenticationAction.login", []),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      // SaveEmployeeid,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(operations)));
